import React from 'react';

import KeyChip from '@dashboard/components/KeyChip';
import Link from '@dashboard/components/mui-atoms/Link';
import { useWaypointTemplateQuery } from '@dashboard/generated/wp/platform';
import useCurrentHref from '@dashboard/hooks/navigate/useCurrentHref';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { Skeleton } from '@mui/material';

type Props = {
  waypointTemplateId?: string | null;
};
export default function TemplateLink({ waypointTemplateId }: Props) {
  const platformId = useCurrentPlatformId();
  const backLinkHref = useCurrentHref();
  const { data } = useWaypointTemplateQuery({
    variables: { id: waypointTemplateId ?? '' },
    skip: !waypointTemplateId,
  });

  if (!waypointTemplateId) {
    return <>--</>;
  }

  const templateName = data?.WaypointTemplate?.name;
  const children = templateName ?? <Skeleton width={250} />;
  return (
    <>
      <Link href={`/o/${platformId}/templates/${waypointTemplateId}`} underline="hover" backLinkHref={backLinkHref}>
        {children}
      </Link>{' '}
      <KeyChip label={waypointTemplateId} tooltipTitle="Copy ID to clipboard" />
    </>
  );
}
